import { render, staticRenderFns } from "./ListInsurance.vue?vue&type=template&id=0db4ce4a"
import script from "./ListInsurance.vue?vue&type=script&lang=js"
export * from "./ListInsurance.vue?vue&type=script&lang=js"
import style0 from "./ListInsurance.vue?vue&type=style&index=0&id=0db4ce4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports